var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile is-parent is-vertical"},[_c('div',{staticClass:"tile is-child box tile-box is-dark"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }